export const SIZES = {
  mobile: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1200,
} as const;

export const QUERIES = {
  maxMobile: `@media (max-width: ${SIZES.mobile}px)`,
  maxTablet: `@media (max-width: ${SIZES.tablet}px)`,
  maxLaptop: `@media (max-width: ${SIZES.laptop}px)`,
  maxDesktop: `@media (max-width: ${SIZES.desktop}px)`,
  minMobile: `@media (min-width: ${SIZES.mobile}px)`,
  minTablet: `@media (min-width: ${SIZES.tablet}px)`,
  minLaptop: `@media (min-width: ${SIZES.laptop}px)`,
  minDesktop: `@media (min-width: ${SIZES.desktop}px)`,
} as const;
